import AuthCode from "react-auth-code-input";
import {Box, styled} from "@mui/material";
import {red} from "@mui/material/colors";

const Wrapper = styled(Box)(({theme}) => ({
    "& .MuiAuthInputBase-root": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        direction: "rtl",
    },
    "& .MuiAuthInputBase-input": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: 4,
        backgroundColor: theme.palette.background.box,
        color: theme.palette.text.primary,
        width: "2rem",
        height: "2rem",
        marginLeft: "12px",
        borderRadius: 5,
        border: "1px solid rgba(0, 0, 0, 0.12)",
        outline: "none!important",
        transition: "border .15s ease-in-out",
        "&:last-of-type": {
            marginLeft: 0,
        },
        "&:hover, &:focus-visible, &:focus": {borderColor: theme.palette.primary.main},
        "&:focus-visible": {borderWidth: 2},
        "&.Mui-error": {borderColor: red[500]},
        [theme.breakpoints.up('sm')]: {
            width: "3rem",
            height: "3rem",
        },
        [theme.breakpoints.up('md')]: {
          fontSize: "1rem"
        },
    }
}));


const AuthCodeInput = ({InputProps, onChange, onCompleted, ...props}) => {

    const defaultLength = 6;
    const handleChange = (newNumber) => {
        if (InputProps.length) {
            if (newNumber?.length === InputProps.length && onCompleted) onCompleted(newNumber);
        }
        else if (newNumber?.length === defaultLength && onCompleted) onCompleted(newNumber);
        onChange(newNumber);
    }

    return <Wrapper {...props}>
        <AuthCode
            containerClassName="MuiAuthInputBase-root"
            inputClassName="MuiAuthInputBase-input"
            length={defaultLength}
            onChange={handleChange}
            autocomplete="one-time-code"
            {...InputProps}/>
    </Wrapper>
}
export default AuthCodeInput;